import { render, staticRenderFns } from "./listaCultivos.vue?vue&type=template&id=10004688&scoped=true&"
import script from "./listaCultivos.vue?vue&type=script&lang=js&"
export * from "./listaCultivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10004688",
  null
  
)

export default component.exports